export const SESSION_PARTNER_STATE_WAITING = 'SESSION_PARTNER_STATE_WAITING'
export const SESSION_PARTNER_STATE_JOINED = 'SESSION_PARTNER_STATE_JOINED'
export const SESSION_PARTNER_STATE_DECLINED = 'SESSION_PARTNER_STATE_DECLINED'
export const SESSION_PARTNER_STATE_LEFT = 'SESSION_PARTNER_STATE_LEFT'
